import { render } from "./viewUserRole.vue?vue&type=template&id=ed8d640e&scoped=true"
import script from "./viewUserRole.vue?vue&type=script&lang=js"
export * from "./viewUserRole.vue?vue&type=script&lang=js"

import "./viewUserRole.vue?vue&type=style&index=0&id=ed8d640e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed8d640e"]])

export default __exports__